import {
  getCategoryPageTypeConfig,
  getPageTypeForSlug,
} from './categoryPageTypes';

const BASE_NUMERIC_FILTERS = [
  'item_availability=0',
  'visibility>1',
  'visibility<4',
];

/**
 * Builds the Algolia `numericFilters` array for the category page.
 *
 * Shared by both `<Configure>` sites (the root index in `index.js` and the sort
 * replica `<Index>` in `CategoryAlgoliaLayout`) so the replica cannot drift.
 */
const buildCategoryAlgoliaNumericFilters = ({
  slug,
  pageType,
  minWidth,
  maxWidth,
  nowMs,
}) => {
  const { extraNumericFilters } = getCategoryPageTypeConfig(
    pageType ?? getPageTypeForSlug(slug)
  );

  const filterList = [...BASE_NUMERIC_FILTERS, ...extraNumericFilters(nowMs)];

  const minNum = parseInt(minWidth, 10);
  const maxNum = parseInt(maxWidth, 10);

  if (!Number.isNaN(minNum) && minNum >= 1) {
    filterList.push(`item_width>=${minNum}`);
  }

  if (!Number.isNaN(maxNum) && maxNum <= 300) {
    filterList.push(`item_width<=${maxNum}`);
  }

  return filterList;
};

export default buildCategoryAlgoliaNumericFilters;
